import React from "react";
import "./Skill.css";
function Skill() {
  return (
    <div className="skill-container" id="skill">
      <div className="skill-card">
        <div className="skill-parent">
          <div className="skill-heading">
            <h1>Skill</h1>
          </div>
          <div className="skill-deatils">
            <div className="skill-list">
              <ul>
                <li>
                  <i className="fa fa-check"></i> C Programming
                </li>
                <span>Intermetaite</span>
                <li>
                  {" "}
                  <i className="fa fa-check"></i> C++ Programming
                </li>
                <span>Intermetaite</span>
              </ul>
            </div>
            <div className="skill-list2">
              <li>
                {" "}
                <i className="fa fa-check"></i> Html
              </li>
              <span>Intermetaite</span>
              <li>
                {" "}
                <i className="fa fa-check"></i> Css3
              </li>
              <span>Intermetaite</span>
              <li>
                {" "}
                <i className="fa fa-check"></i> JavaScript
              </li>
              <span>Intermetaite</span>
              <li>
                {" "}
                <i className="fa fa-check"></i> React.js
              </li>
              <span>Intermetaite</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Skill;
